import { useContentLibraryFlag } from '@/hooks/useContentLibraryFlag';
import { SeoAutopilotPanelLegacy } from './SeoAutopilotPanelLegacy';
import { SeoAutopilotConsole } from './seo-autopilot/SeoAutopilotConsole';

/* SEO autopilot panel entry point. content_library_v1 ON -> the redesigned console
 * (owner 25-10-2026); OFF -> today's panel exactly (Delta UI IVG GATE: one switch turns
 * on everything). While the flag is loading nothing renders (no flash, no fetch). */
export function SeoAutopilotPanel({ expanded = false }: { expanded?: boolean }) {
  const flag = useContentLibraryFlag();
  if (flag.isLoading) return null;
  return flag.enabled ? <SeoAutopilotConsole expanded={expanded} /> : <SeoAutopilotPanelLegacy />;
}
